import { toast } from "vue3-toastify"
import 'vue3-toastify/dist/index.css';
// import amoirie from ""

export default function (content,type="error"){
    toast(content,{
        type:type == "error"?toast.TYPE.ERROR:(type == "success" ? toast.TYPE.SUCCESS:toast.TYPE.INFO),
        icon:() => (
            
            <img src="/img/amoirie.png"  style={{ height: '30px',width:'50px' }}/>
          ),
        autoClose:true,
        
        "dangerouslyHTMLString": true,
        theme:toast.THEME.LIGHT,
    });
}